module.exports = __webpack_public_path__ + "img/2023.c7c31cba.jpg";